export default __webpack_public_path__ + "static/media/gameplayReleaseBgMb.9ad2ec0a.png";